module.exports = "../images/cabin-8-person-1@2x.jpg?v=dd40151";